class Cookie {
    constructor(backgroundColor, buttonColor, textColor) {
        this.backgroundColor = backgroundColor;
        this.buttonColor = buttonColor;
        this.textColor = textColor;
    }

    setup() {
        window.cookieconsent.initialise({
            'palette': {
                'popup': {
                    'background': this.backgroundColor,
                    'text': this.textColor
                },
                'button': {
                    'background': this.buttonColor
                }
            },
            'content': {
                'message': 'Webové stránky používají k poskytování služeb, personalizaci reklam a analýze návštěvnosti soubory cookie. Informace, jak tyto stránky používáte, sdílíme se svými partnery pro sociální média, inzerci a analýzy. Pro více informací o nastavení cookies najdete',
                'dismiss': 'Rozumím',
                'link': 'zde'
            }
        });
    }
}

class SmoothScroller {
    constructor(element, animateTime) {
        this.actionButton = document.querySelectorAll(element);
        this.animateTime = animateTime;
    }

    getPageScroll() {
        let yScroll;

        if (window.pageYOffset) {
            yScroll = window.pageYOffset;
        } else if (document.documentElement && document.documentElement.scrollTop) {
            yScroll = document.documentElement.scrollTop;
        } else if (document.body) {
            yScroll = document.body.scrollTop;
        }

        return yScroll;
    }

    setup() {
        let thisClass = this;
        let body = document.body;

        for (let i = 0; i < this.actionButton.length; i++) {
            let elem = this.actionButton[i];
            elem.addEventListener('click', function (event) {
                let targetOffset = Math.min(
                    document.getElementById(event.target.hash.substr(1)).offsetTop,
                    Math.max(
                        document.body.scrollHeight,
                        document.body.offsetHeight,
                        document.documentElement.clientHeight,
                        document.documentElement.scrollHeight,
                        document.documentElement.offsetHeight
                    ) - window.innerHeight);
                let currentPosition = thisClass.getPageScroll();

                body.classList.add('in-transition');

                body.style.WebkitTransform = "translate(0, -" + (targetOffset - currentPosition) + "px)";
                body.style.MozTransform = "translate(0, -" + (targetOffset - currentPosition) + "px)";
                body.style.transform = "translate(0, -" + (targetOffset - currentPosition) + "px)";

                window.setTimeout(function () {
                    body.classList.remove('in-transition');
                    body.style.cssText = "";
                    window.scrollTo(0, targetOffset);
                }, thisClass.animateTime);

                event.preventDefault();

            }, false);
        }
    }
}

class MapRenderer {
    constructor(element, lat, lng, zoom) {
        this.lat = lat;
        this.lng = lng;
        this.zoom = zoom;
        this.element = document.getElementById('Map');
    }

    set style(style) {
        this._style = style;
    }

    get style() {
        return this._style;
    }

    set marker(marker) {
        this._marker = marker;
    }

    get marker() {
        return this._marker;
    }

    render() {
        /* global google */
        this.map = new google.maps.Map(this.element, {
            center: {lat: this.lat, lng: this.lng},
            zoom: this.zoom,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: this.style
        });

        /* global Waypoint */
        let waypointMap = new Waypoint({
            element: document.getElementById('Map'),
            handler: (direction) => {
                if (direction === 'down') {
                    this.marker = MapRenderer.generatedMarker(this.map, this.lat, this.lng);
                    new google.maps.Marker(this.marker);
                    waypointMap.destroy();
                }
            },
            offset: '80%'
        });
    }

    static generatedStyle () {
        return [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#461036"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#461036"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fff1ff"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fff8ff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "color": "#461036"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#461036"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#461036"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffd200"
                    },
                    {
                        "weight": "2.00"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#461036"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffdfff"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#461036"
                    }
                ]
            }
        ];
    }

    static generatedMarker(map, lat, lng) {
        return {
            position: {lat: lat, lng: lng},
            map: map,
            title: 'Maminčina cukrárna a kavárna',
            icon: {
                anchor: new google.maps.Point(16, 53),
                url: 'data:image/svg+xml;charset=utf-8, ' + encodeURIComponent('<svg width="128" height="212" viewBox="0 0 340.16 571.94" xmlns="http://www.w3.org/2000/svg"><path d="m170.3 553.73c-14.13-36.84-24.3-68.06-33.3-95.73-10-31-18.73-57.7-30-82.95l-.17-.36-.18-.35c-17-31.27-32-55.74-45.18-77.34-5.46-8.93-10.62-17.37-15.31-25.31-22.89-38.69-34.77-66-36.13-107.82v-.27c0-1.13-.06-2.28-.08-3.43-.61-34.84 14.86-72.78 40.37-99 31.19-32.03 74.77-51.17 116.68-51.17h1.88 1.06c40.27.79 81.32 17.6 112.6 46.12l.54.52.1.07c2.28 2.1 4.48 4.24 6.55 6.37 25.54 26.26 41 64.22 40.42 99 0 .83 0 1.6-.05 2.36-1.11 40.63-12.35 67.79-31.42 101-6 10.42-12.7 21.39-19.83 33-12.75 20.77-27.2 44.31-44.13 75.45l-.19.35-.16.36c-12.08 27.16-21.84 56.42-33.15 90.3-8.63 25.92-18.34 55.04-30.92 88.83z" fill="#461036"/><g fill="#fff"><path d="m167.82 20h1.91c38 .76 76.63 16.65 106.13 43.59l.3.26c2.22 2 4.37 4.13 6.39 6.21 23.75 24.43 38.15 59.64 37.59 91.9v.11c0 .69 0 1.38-.05 2.06v.18c-1.09 38.69-11.38 63.69-30.09 96.24-5.9 10.29-12.59 21.19-19.68 32.74-12.81 20.88-27.34 44.54-44.39 75.92l-.38.69-.32.73c-12.28 27.6-22.12 57.07-33.5 91.19-6.35 19-13.29 39.84-21.53 63-9.36-25.92-16.83-48.92-23.64-69.89-10.14-31.23-18.9-58.19-30.35-83.92l-.32-.73-.38-.69c-17.11-31.5-32.15-56.09-45.43-77.79-5.44-8.9-10.58-17.3-15.24-25.19-22-37.17-33.41-63.32-34.73-102.89v-.43c0-1.08-.07-2.17-.08-3.28-.56-32.27 13.82-67.47 37.54-91.86 29.1-29.97 69.7-47.92 108.74-48.15zm.18-20h-.88c-48.46 0-93.72 23.14-123.9 54.18-26.97 27.74-43.86 68.14-43.22 106.15q0 1.81.09 3.6v.07c1.44 45.13 14.82 74.38 37.52 112.75 15.85 26.81 36.26 58.08 60.31 102.34 21.4 48.1 33.54 102.24 65 183.28 3.43 8.85 6.2 9.55 7.54 9.55 1.22 0 3.95-.73 7.26-9.54 30.59-81.38 44.38-135.52 65.78-183.62 26.57-48.88 47.4-79.57 63.85-108.26 19.95-34.77 31.58-63.15 32.73-105.63 0-.84.05-1.69.06-2.54.66-38-16.28-78.45-43.25-106.19q-3.61-3.72-7.5-7.27c-30.62-27.95-73.66-47.94-119.31-48.87z"/><text font-family="Cinzel" font-size="230" transform="translate(63.01 240.31)">M</text></g></svg>'),
                scaledSize: new google.maps.Size(32, 53)
            },
            animation: google.maps.Animation.DROP
        };
    }
}

function initMap() { // eslint-disable-line no-unused-vars
}

window.addEventListener('load', function(){
    let cookie = new Cookie('#fff1ff', '#461036', '#461036');
    cookie.setup();

    let menuScroll = new SmoothScroller('.menu__nav__item__link', 500);
    menuScroll.setup();

    /* global Siema */
    let mainSlider = new Siema({
        selector: '#MainSlider',
        duration: 1000,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: true,
        rtl: false
    });

    setInterval(() => mainSlider.next(), 5000);

    let map = new MapRenderer('Map', 50.266473, 15.499111, 16);
    map.style = MapRenderer.generatedStyle();
    map.render();

    /* global WAMediaBox */
    WAMediaBox.bindAll(document.getElementById('InteriorGallery'));
    WAMediaBox.bindAll(document.getElementById('OwnWorkGallery'));
    WAMediaBox.lang = {
        prev: "Předchozí",
        next: "Další",
        close: "Zavřít",
        openInNew: "Otevřít"
    };
    
    function closeDialog(element) {
        element.style.display = "none";
    }
    var okno = document.getElementById("okno");
    if (okno) {
        if (okno.dataset.show === "yes") {
            okno.style.display = "block"
        } else {
            okno.style.display = "none"
        }
        okno.getElementsByClassName("cover__dialog__box__button")[0].addEventListener('click', function() {closeDialog(okno);});
    }
});